import React from 'react'

import { TGetItemFn, TRemoveItemFn, TSetItemFn } from '@/config/types'

import { authContext } from './context'
import { useProvideAuth } from './useAuth'

export type TAuthProviderProps = {
  children: React.ReactNode
  getItem: TGetItemFn
  setItem: TSetItemFn
  removeItem: TRemoveItemFn
}

export function AuthProvider({ children, getItem, setItem, removeItem }: TAuthProviderProps) {
  const auth = useProvideAuth(getItem, setItem, removeItem)

  return <authContext.Provider value={auth}>{children}</authContext.Provider>
}
